document.addEventListener('DOMContentLoaded', function () {
  var herosliderSwipers = [];

  function initherosliderSwiper(swiperContainer) {
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;
      var slider = swiperContainer.dataset.slider;
    
      var herosliderSwiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          navigation: {
              nextEl: swiperContainer.querySelector(".slider-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".slider-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".slider-swiper-pagination"),
              clickable: true,
          },
      });

      // Hover par autoplay stop and start functionality
      swiperContainer.addEventListener('mouseenter', function () {
          herosliderSwiper.autoplay.stop();  // Hover karta autoplay stop
      });

      swiperContainer.addEventListener('mouseleave', function () {
          herosliderSwiper.autoplay.start();  // Mouse hata pachhi autoplay start
      });

      herosliderSwipers.push(herosliderSwiper);
  }

  // Initialize Hero slider Swiper on page load
  document.querySelectorAll('.classic-container').forEach(function (swiperContainer) {
      initherosliderSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Hero slider Swiper on section select
      herosliderSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      herosliderSwipers = [];
      document.querySelectorAll('.classic-container').forEach(function (swiperContainer) {
          initherosliderSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Hero slider Swiper on section deselect if necessary
      herosliderSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      herosliderSwipers = [];
  });
});

// featured collection slider js

document.addEventListener('DOMContentLoaded', function () {
  var FeaturedcollectionSwipers = [];

  function initFeaturedcollectionSwiper(swiperContainer) {
      var enable = swiperContainer.dataset.enable;
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

    if (enable) {
      var FeaturedcollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".featured-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".featured-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".featured-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace
            },
            768: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace
            },
        },
      });

      // Add hover functionality to stop and start autoplay
      swiperContainer.addEventListener('mouseenter', function () {
          FeaturedcollectionSwiper.autoplay.stop();  // Autoplay stops on hover
      });

      swiperContainer.addEventListener('mouseleave', function () {
          FeaturedcollectionSwiper.autoplay.start();  // Autoplay resumes after hover
      });

      FeaturedcollectionSwipers.push(FeaturedcollectionSwiper);
    }
  }

  // Initialize Featured collection Swiper on page load
  document.querySelectorAll('.featured-slider').forEach(function (swiperContainer) {
      initFeaturedcollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Featured collection Swiper on section select
      FeaturedcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      FeaturedcollectionSwipers = [];
      document.querySelectorAll('.featured-slider').forEach(function (swiperContainer) {
          initFeaturedcollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Featured collection Swiper on section deselect if necessary
      FeaturedcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      FeaturedcollectionSwipers = [];
  });
});

// tab collection slider js

document.addEventListener('DOMContentLoaded', function () {
  var TabcollectionSwipers = [];

  function initTabcollectionSwiper(swiperContainer) {
      var enable = swiperContainer.dataset.enable;
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

    if (enable) {
      var TabcollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".tab-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".tab-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".tab-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace
            },
            768: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace
            },
        },
      });

      // Add hover functionality to stop and start autoplay
      swiperContainer.addEventListener('mouseenter', function () {
          TabcollectionSwiper.autoplay.stop();  // Stop autoplay on hover
      });

      swiperContainer.addEventListener('mouseleave', function () {
          TabcollectionSwiper.autoplay.start();  // Resume autoplay after hover
      });

      TabcollectionSwipers.push(TabcollectionSwiper);
    }
  }

  // Initialize Tab collection Swiper on page load
  document.querySelectorAll('.tab-slider').forEach(function (swiperContainer) {
      initTabcollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Tab collection Swiper on section select
      TabcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      TabcollectionSwipers = [];
      document.querySelectorAll('.tab-slider').forEach(function (swiperContainer) {
          initTabcollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Tab collection Swiper on section deselect if necessary
      TabcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      TabcollectionSwipers = [];
  });
});

// blog slider js

document.addEventListener('DOMContentLoaded', function () {
  var FeaturedblogSwipers = [];

  function initFeaturedblogSwiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;
  
      var FeaturedblogSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".blog-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".blog-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".blog-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace
            },
            768: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace
            },
        },
      });

      // Add hover functionality to stop and start autoplay
      swiperContainer.addEventListener('mouseenter', function () {
          FeaturedblogSwiper.autoplay.stop();  // Stop autoplay on hover
      });

      swiperContainer.addEventListener('mouseleave', function () {
          FeaturedblogSwiper.autoplay.start();  // Resume autoplay after hover
      });

      FeaturedblogSwipers.push(FeaturedblogSwiper);
  }

  // Initialize Featured blog Swiper on page load
  document.querySelectorAll('.blog-slider').forEach(function (swiperContainer) {
      initFeaturedblogSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Featured blog Swiper on section select
      FeaturedblogSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      FeaturedblogSwipers = [];
      document.querySelectorAll('.blog-slider').forEach(function (swiperContainer) {
          initFeaturedblogSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Featured blog Swiper on section deselect if necessary
      FeaturedblogSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      FeaturedblogSwipers = [];
  });
});

// category collection 1 slider

document.addEventListener('DOMContentLoaded', function () {
  var categorycollection1Swipers = [];

  function initcategorycollection1Swiper(swiperContainer) {

      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;

      var categorycollection1Swiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".category1-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".category1-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".category1-swiper-pagination"),
              clickable: true,
          },
          breakpoints : {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace,
            },
            480: {
                slidesPerView: tablet,
                spaceBetween: mobilespace,
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace,
            },
            768: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace,
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace,
            },
            1200: {
                slidesPerView: desktop,
                spaceBetween: desktopspace,
            },
          }
      });

      // Add hover functionality to stop and start autoplay
      swiperContainer.addEventListener('mouseenter', function () {
          categorycollection1Swiper.autoplay.stop();  // Stop autoplay on hover
      });

      swiperContainer.addEventListener('mouseleave', function () {
          categorycollection1Swiper.autoplay.start();  // Resume autoplay after hover
      });

      categorycollection1Swipers.push(categorycollection1Swiper);
  }

  // Initialize category collection Swiper on page load
  document.querySelectorAll('.main-collections-list-wrapper1').forEach(function (swiperContainer) {
      initcategorycollection1Swiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize category collection Swiper on section select
      categorycollection1Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      categorycollection1Swipers = [];
      document.querySelectorAll('.main-collections-list-wrapper1').forEach(function (swiperContainer) {
          initcategorycollection1Swiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup category collection Swiper on section deselect if necessary
      categorycollection1Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      categorycollection1Swipers = [];
  });
});

// category collection 3 slider

document.addEventListener('DOMContentLoaded', function () {
  var categorycollection3Swipers = [];

  function initcategorycollection3Swiper(swiperContainer) {

      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;

      var categorycollection3Swiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".category3-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".category3-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".category3-swiper-pagination"),
              clickable: true,
          },
          breakpoints : {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace,
            },
            480: {
                slidesPerView: tablet,
                spaceBetween: mobilespace,
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace,
            },
            768: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace,
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace,
            },
            1200: {
                slidesPerView: desktop,
                spaceBetween: desktopspace,
            },
          }
      });

      // Add hover functionality to stop and start autoplay
      swiperContainer.addEventListener('mouseenter', function () {
          categorycollection3Swiper.autoplay.stop();  // Stop autoplay on hover
      });

      swiperContainer.addEventListener('mouseleave', function () {
          categorycollection3Swiper.autoplay.start();  // Resume autoplay after hover
      });

      categorycollection3Swipers.push(categorycollection3Swiper);
  }

  // Initialize category collection Swiper on page load
  document.querySelectorAll('.main-collections-list-wrapper3').forEach(function (swiperContainer) {
      initcategorycollection3Swiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize category collection Swiper on section select
      categorycollection3Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      categorycollection3Swipers = [];
      document.querySelectorAll('.main-collections-list-wrapper3').forEach(function (swiperContainer) {
          initcategorycollection3Swiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup category collection Swiper on section deselect if necessary
      categorycollection3Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      categorycollection3Swipers = [];
  });
});

// multicolumn slider
document.addEventListener('DOMContentLoaded', function () {
  var MulticolumnSwipers = [];

  function initmulticolumnSwiper(swiperContainer) {
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var MulticolumnSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 30,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".multicolumn-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".multicolumn-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".multicolumn-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: 15
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 15
            },
            768: {
                slidesPerView: largeTablet,
                spaceBetween: 15
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: 30
            },
          },
      });

      // Add hover functionality to stop and start autoplay
      swiperContainer.addEventListener('mouseenter', function () {
          MulticolumnSwiper.autoplay.stop();  // Stop autoplay on hover
      });

      swiperContainer.addEventListener('mouseleave', function () {
          MulticolumnSwiper.autoplay.start();  // Resume autoplay after hover
      });

      MulticolumnSwipers.push(MulticolumnSwiper);
  }

  // Initialize Multicolumn Swiper on page load
  document.querySelectorAll('.multicolumn-slider').forEach(function (swiperContainer) {
      initmulticolumnSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Multicolumn Swiper on section select
      MulticolumnSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      MulticolumnSwipers = [];
      document.querySelectorAll('.multicolumn-slider').forEach(function (swiperContainer) {
          initmulticolumnSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Multicolumn Swiper on section deselect if necessary
      MulticolumnSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      MulticolumnSwipers = [];
  });
});

// Best selling collection slider js

document.addEventListener('DOMContentLoaded', function () {
  var BestsellingcollectionSwipers = [];

  function initBestsellingcollectionSwiper(swiperContainer) {
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var BestsellingcollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 30,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".bestselling-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".bestselling-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".bestselling-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: 15
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 15
            },
            768: {
                slidesPerView: largeTablet,
                spaceBetween: 15
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: 30
            },
          },
      });

      // Add hover functionality to stop and start autoplay
      swiperContainer.addEventListener('mouseenter', function () {
          BestsellingcollectionSwiper.autoplay.stop();  // Stop autoplay on hover
      });

      swiperContainer.addEventListener('mouseleave', function () {
          BestsellingcollectionSwiper.autoplay.start();  // Resume autoplay after hover
      });

      BestsellingcollectionSwipers.push(BestsellingcollectionSwiper);
  }

  // Initialize Bestselling collection Swiper on page load
  document.querySelectorAll('.bestselling-slider').forEach(function (swiperContainer) {
      initBestsellingcollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Bestselling collection Swiper on section select
      BestsellingcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      BestsellingcollectionSwipers = [];
      document.querySelectorAll('.bestselling-slider').forEach(function (swiperContainer) {
          initBestsellingcollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Bestselling collection Swiper on section deselect if necessary
      BestsellingcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      BestsellingcollectionSwipers = [];
  });
});

// Video with text slider js

document.addEventListener('DOMContentLoaded', function () {
  var VideoproductSwipers = [];

  function initVideoproductSwiper(swiperContainer) {
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var VideoproductSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 30,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".videoproduct-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".videoproduct-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".videoproduct-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: 15
            },
            480: {
                slidesPerView: tablet,
                spaceBetween: 15
            },
            768: {
                slidesPerView: largeTablet,
                spaceBetween: 15
            },
            992: {
                slidesPerView: largeTablet,
                spaceBetween: 30
            },
            1200: {
                slidesPerView: desktop,
                spaceBetween: 30
            }
        },
      });

      // Add hover functionality to stop and start autoplay
      swiperContainer.addEventListener('mouseenter', function () {
          VideoproductSwiper.autoplay.stop();  // Stop autoplay on hover
      });

      swiperContainer.addEventListener('mouseleave', function () {
          VideoproductSwiper.autoplay.start();  // Resume autoplay after hover
      });

      VideoproductSwipers.push(VideoproductSwiper);
  }

  // Initialize Videoproduct collection Swiper on page load
  document.querySelectorAll('.video-product-slider').forEach(function (swiperContainer) {
      initVideoproductSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Videoproduct collection Swiper on section select
      VideoproductSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      VideoproductSwipers = [];
      document.querySelectorAll('.video-product-slider').forEach(function (swiperContainer) {
          initVideoproductSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Videoproduct collection Swiper on section deselect if necessary
      VideoproductSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      VideoproductSwipers = [];
  });
});

// Gallery slider js

document.addEventListener('DOMContentLoaded', function () {
  var GallerySwipers = [];

  function initGallerySwiper(swiperContainer) {
      var enable = swiperContainer.dataset.enable;
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      if (enable) {
          var GallerySwiper = new Swiper(swiperContainer, {
              slidesPerView: desktop,
              spaceBetween: desktopspace,
              loop: loop,
              autoplay: autoplay,
              speed: speed,
              grabCursor: true,
              a11y: false,
              navigation: {
                  nextEl: swiperContainer.querySelector(".gallery-swiper-button-next"),
                  prevEl: swiperContainer.querySelector(".gallery-swiper-button-prev")
              },
              pagination: {
                  el: swiperContainer.querySelector(".gallery-swiper-pagination"),
                  clickable: true,
              },
              breakpoints: {
                  320: {
                      slidesPerView: mobile,
                      spaceBetween: mobilespace
                  },
                  576: {
                      slidesPerView: tablet,
                      spaceBetween: mobilespace
                  },
                  768: {
                      slidesPerView: largeTablet,
                      spaceBetween: mobilespace
                  },
                  992: {
                      slidesPerView: desktop,
                      spaceBetween: desktopspace
                  },
              },
          });

          // Add hover functionality to stop and start autoplay
          swiperContainer.addEventListener('mouseenter', function () {
              GallerySwiper.autoplay.stop(); // Stop autoplay on hover
          });

          swiperContainer.addEventListener('mouseleave', function () {
              GallerySwiper.autoplay.start(); // Resume autoplay after hover
          });

          GallerySwipers.push(GallerySwiper);
      }
  }

  // Initialize Gallery Swiper on page load
  document.querySelectorAll('.gallery-slider').forEach(function (swiperContainer) {
      initGallerySwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Gallery Swiper on section select
      GallerySwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      GallerySwipers = [];
      document.querySelectorAll('.gallery-slider').forEach(function (swiperContainer) {
          initGallerySwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Gallery Swiper on section deselect if necessary
      GallerySwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      GallerySwipers = [];
  });
});

// Gallery slider2 js

document.addEventListener('DOMContentLoaded', function () {
    var Gallery2Swipers = [];

    function initGallery2Swiper(swiperContainer) {
        var enable = swiperContainer.dataset.enable;
        var desktopspace = swiperContainer.dataset.desktopspace;
        var mobilespace = swiperContainer.dataset.mobilespace;
        var desktop = swiperContainer.dataset.desktop;
        var largeTablet = swiperContainer.dataset.largetablet;
        var tablet = swiperContainer.dataset.tablet;
        var mobile = swiperContainer.dataset.mobile;
        var autoplay = swiperContainer.dataset.autoplay === "true";
        var loop = swiperContainer.dataset.loop === "true";
        var speed = swiperContainer.dataset.speed;

        if (enable) {
            var Gallery2Swiper = new Swiper(swiperContainer, {
                slidesPerView: desktop,
                spaceBetween: desktopspace,
                loop: loop,
                autoplay: autoplay,
                speed: speed,
                grabCursor: true,
                a11y: false,
                navigation: {
                    nextEl: swiperContainer.querySelector(".gallery2-swiper-button-next"),
                    prevEl: swiperContainer.querySelector(".gallery2-swiper-button-prev")
                },
                pagination: {
                    el: swiperContainer.querySelector(".gallery2-swiper-pagination"),
                    clickable: true,
                },
                breakpoints: {
                    320: {
                        slidesPerView: mobile,
                        spaceBetween: mobilespace
                    },
                    576: {
                        slidesPerView: tablet,
                        spaceBetween: mobilespace
                    },
                    768: {
                        slidesPerView: largeTablet,
                        spaceBetween: mobilespace
                    },
                    992: {
                        slidesPerView: desktop,
                        spaceBetween: desktopspace
                    },
                },
            });

            // Add hover functionality to stop and start autoplay
            swiperContainer.addEventListener('mouseenter', function () {
                Gallery2Swiper.autoplay.stop(); // Stop autoplay on hover
            });

            swiperContainer.addEventListener('mouseleave', function () {
                Gallery2Swiper.autoplay.start(); // Resume autoplay after hover
            });

            Gallery2Swipers.push(Gallery2Swiper);
        }
    }

    // Initialize Gallery2 Swiper on page load
    document.querySelectorAll('.gallery2-slider').forEach(function (swiperContainer) {
        initGallery2Swiper(swiperContainer);
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize Gallery2 Swiper on section select
        Gallery2Swipers.forEach(function (swiper) {
            swiper.destroy();
        });
        Gallery2Swipers = [];
        document.querySelectorAll('.gallery2-slider').forEach(function (swiperContainer) {
            initGallery2Swiper(swiperContainer);
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup Gallery2 Swiper on section deselect if necessary
        Gallery2Swipers.forEach(function (swiper) {
            swiper.destroy();
        });
        Gallery2Swipers = [];
    });
});

// Automated image slider js

document.addEventListener('DOMContentLoaded', function () {
    var AutomatedSwipers = [];

    function initAutomatedSwiper(swiperContainer) {
        var enable = swiperContainer.dataset.enable;
        var desktopspace = swiperContainer.dataset.desktopspace;
        var mobilespace = swiperContainer.dataset.mobilespace;
        var desktop = swiperContainer.dataset.desktop;
        var largeTablet = swiperContainer.dataset.largetablet;
        var tablet = swiperContainer.dataset.tablet;
        var mobile = swiperContainer.dataset.mobile;
        var autoplay = swiperContainer.dataset.autoplay === "true";
        var loop = swiperContainer.dataset.loop === "true";
        var speed = swiperContainer.dataset.speed;

        if (enable) {
            var AutomatedSwiper = new Swiper(swiperContainer, {
                direction: "horizontal",
                slidesPerView: desktop,
                spaceBetween: desktopspace,
                loop: loop,
                autoplay: autoplay,
                speed: speed,
                grabCursor: true,
                a11y: false,
                parallax: true,
                centeredSlides: true,
                effect: "coverflow",
                coverflowEffect: {
                    rotate: 45,
                    slideShadows: true
                },
                navigation: {
                    nextEl: swiperContainer.querySelector(".automated-swiper-button-next"),
                    prevEl: swiperContainer.querySelector(".automated-swiper-button-prev")
                },
                pagination: {
                    el: swiperContainer.querySelector(".automated-swiper-pagination"),
                    clickable: true,
                },
                breakpoints: {
                    320: {
                        slidesPerView: mobile,
                        spaceBetween: mobilespace
                    },
                    576: {
                        slidesPerView: tablet,
                        spaceBetween: mobilespace
                    },
                    768: {
                        slidesPerView: largeTablet,
                        spaceBetween: mobilespace
                    },
                    992: {
                        slidesPerView: desktop,
                        spaceBetween: desktopspace
                    },
                },
            });

            // Add hover functionality to stop and start autoplay
            swiperContainer.addEventListener('mouseenter', function () {
                AutomatedSwiper.autoplay.stop(); // Stop autoplay on hover
            });

            swiperContainer.addEventListener('mouseleave', function () {
                AutomatedSwiper.autoplay.start(); // Resume autoplay after hover
            });

            AutomatedSwipers.push(AutomatedSwiper);
        }
    }

    // Initialize Automated Swiper on page load
    document.querySelectorAll('.automated-slider').forEach(function (swiperContainer) {
        initAutomatedSwiper(swiperContainer);
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize Automated Swiper on section select
        AutomatedSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        AutomatedSwipers = [];
        document.querySelectorAll('.automated-slider').forEach(function (swiperContainer) {
            initAutomatedSwiper(swiperContainer);
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup Automated Swiper on section deselect if necessary
        AutomatedSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        AutomatedSwipers = [];
    });
});

// Automated image slider2 js

document.addEventListener('DOMContentLoaded', function () {
    var AutomatedSwipers = [];

    function initAutomatedSwiper(swiperContainer) {
        var enable = swiperContainer.dataset.enable;
        var desktopspace = parseInt(swiperContainer.dataset.desktopspace);
        var mobilespace = parseInt(swiperContainer.dataset.mobilespace);
        var desktop = parseInt(swiperContainer.dataset.desktop);
        var largeTablet = parseInt(swiperContainer.dataset.largetablet);
        var tablet = parseInt(swiperContainer.dataset.tablet);
        var mobile = parseInt(swiperContainer.dataset.mobile);
        var autoplay = swiperContainer.dataset.autoplay === "true";
        var loop = swiperContainer.dataset.loop === "true";
        var speed = parseInt(swiperContainer.dataset.speed);

        if (enable) {
            var AutomatedSwiper = new Swiper(swiperContainer, {
                direction: "horizontal",
                slidesPerView: desktop,
                spaceBetween: desktopspace,
                loop: loop,
                autoplay: autoplay,
                speed: speed,
                grabCursor: true,
                a11y: false,
                parallax: true,
                centeredSlides: true,
                loopAdditionalSlides: 2,
                effect: "coverflow",
                coverflowEffect: {
                    rotate: 0,
                    stretch: 50,
                    depth: 100,
                    modifier: 4,
                    slideShadows: true
                },
                navigation: {
                    nextEl: swiperContainer.querySelector(".automated2-swiper-button-next"),
                    prevEl: swiperContainer.querySelector(".automated2-swiper-button-prev")
                },
                pagination: {
                    el: swiperContainer.querySelector(".automated2-swiper-pagination"),
                    clickable: true,
                },
                breakpoints: {
                    320: {
                        slidesPerView: mobile,
                        spaceBetween: mobilespace,
                    },
                    576: {
                        slidesPerView: tablet,
                        spaceBetween: mobilespace
                    },
                    768: {
                        slidesPerView: largeTablet,
                        spaceBetween: mobilespace
                    },
                    992: {
                        slidesPerView: desktop,
                        spaceBetween: desktopspace
                    },
                },
                on: {
                    init: function () {
                        this.slideToLoop(1, 0); // Correctly reference the current Swiper instance
                    },
                }
            });

            // Add hover functionality to stop and start autoplay
            swiperContainer.addEventListener('mouseenter', function () {
                AutomatedSwiper.autoplay.stop(); // Stop autoplay on hover
            });

            swiperContainer.addEventListener('mouseleave', function () {
                AutomatedSwiper.autoplay.start(); // Resume autoplay after hover
            });

            AutomatedSwipers.push(AutomatedSwiper);
        }
    }

    // Initialize Automated Swiper on page load
    document.querySelectorAll('.automated2-slider').forEach(function (swiperContainer) {
        initAutomatedSwiper(swiperContainer);
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize Automated Swiper on section select
        AutomatedSwipers.forEach(function (swiper) {
            swiper.destroy(); // Clean up existing Swipers
        });
        AutomatedSwipers = [];
        document.querySelectorAll('.automated2-slider').forEach(function (swiperContainer) {
            initAutomatedSwiper(swiperContainer); // Reinitialize
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup Automated Swiper on section deselect if necessary
        AutomatedSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        AutomatedSwipers = [];
    });
});

// recentview collection slider js

document.addEventListener('DOMContentLoaded', function () {
    var recentviewcollectionSwipers = [];

    function initrecentviewcollectionSwiper(swiperContainer) {
        var desktopspace = swiperContainer.dataset.desktopspace;
        var mobilespace = swiperContainer.dataset.mobilespace;
        var desktop = swiperContainer.dataset.desktop;
        var largeTablet = swiperContainer.dataset.largetablet;
        var tablet = swiperContainer.dataset.tablet;
        var mobile = swiperContainer.dataset.mobile;
        var autoplay = swiperContainer.dataset.autoplay === "true";
        var loop = swiperContainer.dataset.loop === "true";
        var speed = swiperContainer.dataset.speed;

        // Initialize the Swiper instance
        var recentviewcollectionSwiper = new Swiper(swiperContainer, {
            slidesPerView: desktop,
            spaceBetween: desktopspace,
            loop: loop,
            autoplay: autoplay,
            speed: speed,
            grabCursor: true,
            a11y: false,
            navigation: {
                nextEl: swiperContainer.querySelector(".recent-swiper-button-next"),
                prevEl: swiperContainer.querySelector(".recent-swiper-button-prev")
            },
            pagination: {
                el: swiperContainer.querySelector(".recent-swiper-pagination"),
                clickable: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: mobile,
                    spaceBetween: mobilespace
                },
                576: {
                    slidesPerView: tablet,
                    spaceBetween: mobilespace
                },
                768: {
                    slidesPerView: largeTablet,
                    spaceBetween: mobilespace
                },
                992: {
                    slidesPerView: desktop,
                    spaceBetween: desktopspace
                },
            },
        });

        // Add hover functionality to pause and resume autoplay
        swiperContainer.addEventListener('mouseenter', function () {
            recentviewcollectionSwiper.autoplay.stop(); // Stop autoplay on hover
        });

        swiperContainer.addEventListener('mouseleave', function () {
            recentviewcollectionSwiper.autoplay.start(); // Resume autoplay after hover
        });

        recentviewcollectionSwipers.push(recentviewcollectionSwiper);
    }

    // Initialize recent view collection Swiper on page load
    document.querySelectorAll('.recent-slider').forEach(function (swiperContainer) {
        initrecentviewcollectionSwiper(swiperContainer);
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize recent view collection Swiper on section select
        recentviewcollectionSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        recentviewcollectionSwipers = [];
        document.querySelectorAll('.recent-slider').forEach(function (swiperContainer) {
            initrecentviewcollectionSwiper(swiperContainer);
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup recent view collection Swiper on section deselect if necessary
        recentviewcollectionSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        recentviewcollectionSwipers = [];
    });
});

document.addEventListener('DOMContentLoaded', function () {
    var StorelocatorSwipers = [];

    function initStorelocatorSwiper(swiperContainer) {
        var desktopspace = parseInt(swiperContainer.dataset.desktopspace, 10);
        var mobilespace = parseInt(swiperContainer.dataset.mobilespace, 10);
        var desktop = parseInt(swiperContainer.dataset.desktop, 10);
        var largeTablet = parseInt(swiperContainer.dataset.largetablet, 10);
        var tablet = parseInt(swiperContainer.dataset.tablet, 10);
        var mobile = parseInt(swiperContainer.dataset.mobile, 10);
        var autoplay = swiperContainer.dataset.autoplay === "true";
        var loop = swiperContainer.dataset.loop === "true";
        var speed = parseInt(swiperContainer.dataset.speed, 10);

        // Initialize the Swiper only if enabled
        {
            var StorelocatorSwiper = new Swiper(swiperContainer, {
                slidesPerView: desktop,
                spaceBetween: desktopspace,
                loop: loop,
                autoplay: autoplay,
                speed: speed,
                grabCursor: true,
                a11y: false,
                navigation: {
                    nextEl: swiperContainer.querySelector(".locator-swiper-button-next"),
                    prevEl: swiperContainer.querySelector(".locator-swiper-button-prev")
                },
                pagination: {
                    el: swiperContainer.querySelector(".locator-swiper-pagination"),
                    clickable: true,
                },
                breakpoints: {
                    320: {
                        slidesPerView: mobile,
                        spaceBetween: mobilespace
                    },
                    576: {
                        slidesPerView: tablet,
                        spaceBetween: mobilespace
                    },
                    768: {
                        slidesPerView: largeTablet,
                        spaceBetween: mobilespace
                    },
                    992: {
                        slidesPerView: largeTablet,
                        spaceBetween: desktopspace
                    },
                    1200: {
                        slidesPerView: desktop,
                        spaceBetween: desktopspace
                    },
                },
            });

            // Hover functionality to pause and resume autoplay
            swiperContainer.addEventListener('mouseenter', function () {
                StorelocatorSwiper.autoplay.stop(); // Stop autoplay on hover
            });

            swiperContainer.addEventListener('mouseleave', function () {
                StorelocatorSwiper.autoplay.start(); // Resume autoplay after hover
            });

            StorelocatorSwipers.push(StorelocatorSwiper);
        }
    }

    // Initialize Store locator Swiper on page load
    document.querySelectorAll('.locator-slider').forEach(function (swiperContainer) {
        initStorelocatorSwiper(swiperContainer);
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize Store locator Swiper on section select
        StorelocatorSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        StorelocatorSwipers = [];
        document.querySelectorAll('.locator-slider').forEach(function (swiperContainer) {
            initStorelocatorSwiper(swiperContainer);
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup Store locator Swiper on section deselect if necessary
        StorelocatorSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        StorelocatorSwipers = [];
    });
});

document.addEventListener('DOMContentLoaded', function () {
  var BundleSwipers = [];

  function initBundleSwiper(swiperContainer) {
  
      var BundleSwiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          autoplay: false,
          speed: 500,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".bundle-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".bundle-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".bundle-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 0
            }
        },
      });

    BundleSwipers.push(BundleSwiper);
  }

  // Initialize Featured blog Swiper on page load
  document.querySelectorAll('.card-bundle').forEach(function (swiperContainer) {
      initBundleSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Featured blog Swiper on section select
      BundleSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      BundleSwipers = [];
      document.querySelectorAll('.card-bundle').forEach(function (swiperContainer) {
          initBundleSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Featured blog Swiper on section deselect if necessary
      BundleSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      BundleSwipers = [];
  });
});